<section class="catalog">
  <!-- Collection Header -->
  @if (selectedCollection$ | async; as selectedCollection) {
    @if (getCollectionImage(selectedCollection)) {
      <div class=" d-none d-md-block {{ (featuredFilter$ | async)?.values ? 'mb-3' : 'mb-6' }}">
        <app-collection-header
          [imageWide]="(selectedCollection.metafields | metafieldsValue: 'main_category') === 'true'"
          [image]="getCollectionImage(selectedCollection)"
          [title]="selectedCollection.title"
          [text]="selectedCollection.description"
        >
          @if (products$ | async; as products) {
            <span #bottomRight class="mb-1 d-inline-block text-lowercase text-light">
              @if (products.length > 0) {
                {{ products.length }}{{ (page$ | async)?.hasNextPage ? '+' : '' }}
                {{ (products.length === 1 ? 'productresultaat-label' : 'productresultaten-label') | fromDictionary }}
              }
            </span>
          }
        </app-collection-header>
      </div>
    }
    <header class="container topbar-padding-top section-inset-t d-block" [class.d-md-none]="getCollectionImage(selectedCollection)">
      <div class="mt-4 d-flex justify-content-between align-items-center">
        @if (getCollectionImage(selectedCollection)) {
          <span role="heading" aria-level="1" class="h2">{{ selectedCollection.title }}</span>
        } @else {
          <h1 class="h2" [class.mb-0]="(featuredFilter$ | async)?.values">{{ selectedCollection.title }}</h1>
        }

        @if (products$ | async; as products) {
          <span #bottomRight class="">
            @if (products.length > 0) {
              {{ products.length }}{{ (page$ | async)?.hasNextPage ? '+' : '' }}
              {{ (products.length === 1 ? 'productresultaat-label' : 'productresultaten-label') | fromDictionary }}
            }
          </span>
        }
      </div>
    </header>
  } @else {
    <header class="pt-4 mb-4 catalog__header">
      <div class="container topbar-padding-top">
        <h1 class="mb-0 fw-bold">
          {{ searchQuery ? searchQuery : ('producten-overzicht-titel' | fromDictionary) }}
        </h1>
        @if (searchQuery) {
          @if (products$ | async; as products) {
            <span class="mb-1 d-inline-block text-lowercase">
              {{ products.length }}{{ (page$ | async)?.hasNextPage ? '+' : '' }}
              {{ (products.length === 1 ? 'zoekresultaat-label' : 'zoekresultaten-label') | fromDictionary }}
            </span>
          }
        }
      </div>
    </header>
  }

  <!-- Default Header -->

  <div class="container">
    @let showFeaturedFilterRow = (collectionLoading$ | async) !== true && (featuredFilter$ | async);
    <div>
      <!-- Featured filter -->
      @if (showFeaturedFilterRow) {
        <app-product-featured-filter-row
          class="mb-md-4 d-block"
          [filter]="(featuredFilter$ | async) || undefined"
          #featuredFilterRow
        ></app-product-featured-filter-row>
      }
    </div>
    <main class="row">
      @if (activeFilters2.length) {
        <div class="mb-4 quick-filters">
          <ul class="quick-filters__group button-group">
            <!-- <li class="button-group__item">
            <button class="button button-outline button--secondary" (click)="resetFilters()">Alle producten</button>
          </li> -->
            <li class="button-group__item" [class.is-last-quick-action]="activeFilters2.length">
              <button class="button button-outline button--secondary" (click)="resetFilters()">
                {{ 'product-overzicht-snelle-filters-reset' | fromDictionary }}
              </button>
            </li>
            <!-- <ng-container *ngIf="(selectedCollection$ | async)?.filters as filters"></ng-container> -->

            @for (filter of activeFilters2; track filter.id) {
              <li class="button-group__item">
                <button class="button button-outline button--secondary" (click)="removeFilter(filter)">
                  <span>{{ filter.label }}</span>
                  <span class="button__floating-chip chip chip--xxs">
                    <app-icon class="icon-xxxs" anchor="icon-close-xxs"></app-icon>
                  </span>
                </button>
              </li>
            }
          </ul>
        </div>
      }

      @if ((filters$ | async)?.length) {
        <div class="mb-2 d-md-none">
          <button class="button button-link button--secondary" (click)="setFilterPanelState(true)">
            <app-icon anchor="icon-settings"></app-icon>
            <span>{{ 'product-overzicht-mobiel-open-filters-knoptekst' | fromDictionary }}</span>
            @if (activeFilters2.length > 0) {
              <span class="chip chip--xs ms-2">{{ activeFilters2.length }}</span>
            }
          </button>
        </div>
      }
      @if (filters$ | async; as filters) {
        @if (filters.length) {
          <section class="col-md-3 col-lg-2 filter-bar" [class.is--open]="filtersPanelOpen">
            <header class="filter-bar__header d-md-none">
              <span class="mb-0 h4 fw-normal" role="heading" aria-level="2">
                {{ 'product-overzicht-mobiel-filters-titel' | fromDictionary }}
              </span>
              <button (click)="setFilterPanelState(false)" aria-label="Filters sluiten">
                <app-icon anchor="icon-close-xs"></app-icon>
              </button>
            </header>
            @if ((collectionLoading$ | async) !== true) {
              <app-product-filters
                #filterComponent
                class="filter-bar__filters"
                [filters]="filters"
                [initWithValue]="route.snapshot.queryParams"
                (filtered)="handleFilterForm($event)"
              ></app-product-filters>
            }
            <footer class="filter-bar__footer d-md-none">
              <button class="button button-link button--secondary me-3 filter-bar__header__reset" (click)="resetFilters()">
                {{ 'product-overzicht-mobiel-filters-resetten-knoptekst' | fromDictionary }}
              </button>
              <button class="button button--secondary" (click)="applyFilters()">
                <span>{{ 'product-overzicht-mobiel-filters-toepassen-knoptekst' | fromDictionary }}</span>
                @if (activeFiltersLength) {
                  <span class="chip chip--xs ms-2 chip--light">{{ activeFiltersLength }}</span>
                }
              </button>
            </footer>
          </section>
        }
      }
      <div [ngClass]="(filters$ | async)?.length ? 'col-md-9 col-lg-10 ps-md-2' : 'col-12'">
        @if (products$ | async; as products) {
          <ul class="row">
            @for (product of products; track product.id) {
              <li class="mb-5 col-6 col-md-4">
                <app-product-card
                  (addToCart)="handleAddToCart($event)"
                  [collectionHandle]="(selectedCollection$ | async)?.handle"
                  [product]="product"
                  [sizes]="{ xs: 6, md: 2, lg: 1 }"
                ></app-product-card>
              </li>
            }
            @if (!products.length && (loading$ | async) === false) {
              <li class="my-2 mb-5 text-center col-12">
                <p>{{ 'product-overzicht-geen-resultaten' | fromDictionary }}</p>
                <button class="ms-2 button button--secondary" (click)="resetFilters()">
                  {{ 'product-overzicht-filters-resetten-knoptekst' | fromDictionary }}
                </button>
              </li>
            }
            @if (!products.length && (loading$ | async)) {
              <li class="my-2 mb-5 text-center col-12">
                <p>{{ 'product-overzicht-loading' | fromDictionary }}</p>
              </li>
            }
          </ul>
        }
      </div>
      @if (!activeFiltersLength && (page$ | async)?.hasNextPage) {
        <div class="my-5 text-center">
          <button class="button button-outline button--secondary" (click)="loadMore(page$)" [disabled]="(loading$ | async) === true">
            @if ((loading$ | async) === true) {
              <span class="icon-loader css-icon" title="loading..."></span>
            }
            <span>{{ 'product-overzicht-meer-laden-fallback-knoptekst' | fromDictionary }}</span>
          </button>
        </div>
      }

      @if (activeFiltersLength && (filteredPage$ | async)?.hasNextPage) {
        <div class="my-5 text-center">
          <button
            class="button button-outline button--secondary"
            (click)="loadMore(filteredPage$)"
            [disabled]="(loading$ | async) === true"
          >
            @if ((loading$ | async) === true) {
              <span class="icon-loader css-icon" title="loading..."></span>
            }
            <span>{{ 'product-overzicht-meer-laden-fallback-knoptekst' | fromDictionary }}</span>
          </button>
        </div>
      }
      <!-- // faq -->
      <div class="my-4 section-inset-y">
        @if (faqItems() && faqItems().length > 0) {
          @let selectedCol = selectedCollection$ | async;
          @let intro = getHtmlFromRichText(selectedCol?.metafields || [] | metafieldsValue: 'faq_intro');
          @let title = selectedCol?.metafields || [] | metafieldsValue: 'faq_titel';

          <app-faq-section
            [title]="title"
            [intro]="intro"
            [subject]="(selectedCollection$ | async)?.title"
            [group]="faqArray$()"
            [cookiePreferences]="(cookiePrefs$ | async) || undefined"
          ></app-faq-section>
        }
      </div>

      @if (selectedCollection$ | async; as selectedCollection) {
        @if (getHtmlFromRichText(selectedCollection.metafields | metafieldsValue: 'collection_description_rich'); as htmlText) {
          @if ((htmlText | stripHtml).length > 0) {
            <article class="catalog__text" [ngClass]="{ expanded: collectionTextExpanded || (htmlText | stripHtml).length < 600 }">
              <div class="markdown-content" [innerHTML]="htmlText"></div>
              @if (htmlText && (htmlText | stripHtml).length > 600) {
                <div>
                  <button
                    class="button button-link button--md button--secondary"
                    (click)="collectionTextExpanded = !collectionTextExpanded"
                  >
                    @if (!collectionTextExpanded) {
                      <span class="d-flex align-items-center">
                        {{ 'product-overzicht-collectie-toon-meer-knoptekst' | fromDictionary }}
                        <app-icon class="icon-xxs icon-secondary" anchor="icon-chevron-down"></app-icon>
                      </span>
                    }
                    @if (collectionTextExpanded) {
                      <span class="d-flex align-items-center">
                        {{ 'product-overzicht-collectie-toon-minder-knoptekst' | fromDictionary }}
                        <app-icon class="icon-xxs icon-secondary" anchor="icon-chevron-up"></app-icon>
                      </span>
                    }
                  </button>
                </div>
              }
            </article>
          }
        }
      }
    </main>
  </div>
</section>

<app-json-ld [json]="scheme"></app-json-ld>
<app-json-ld [json]="breadcrumbScheme"></app-json-ld>
